// @generated by protoc-gen-es-ns v0.0.0 with parameter "target=ts"
// @generated from file kikoff_canada/protobuf/models/credit/report_account.proto (package kikoff_canada.protobuf.models.credit, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import type { BinaryReadOptions, FieldList, JsonReadOptions, JsonValue, PartialMessage, PlainMessage } from "@bufbuild/protobuf";
import { Message, proto3, Timestamp } from "@bufbuild/protobuf";
import { Address } from "../../types/pii/address_pb.js";

/**
 * @generated from message kikoff_canada.protobuf.models.credit.ReportAccount
 */
export class ReportAccount extends Message<ReportAccount> {
  /**
   * @generated from field: string id = 1;
   */
  id = "";

  /**
   * @generated from field: string name = 2;
   */
  name = "";

  /**
   * @generated from field: kikoff_canada.protobuf.models.credit.ReportAccount.Type type = 3;
   */
  type = ReportAccount.Type.OTHER;

  /**
   * @generated from field: google.protobuf.Timestamp opened_at = 4;
   */
  openedAt?: Timestamp;

  /**
   * @generated from field: optional google.protobuf.Timestamp closed_at = 5;
   */
  closedAt?: Timestamp;

  /**
   * @generated from field: google.protobuf.Timestamp last_reported_at = 6;
   */
  lastReportedAt?: Timestamp;

  /**
   * @generated from field: google.protobuf.Timestamp last_activity_at = 7;
   */
  lastActivityAt?: Timestamp;

  /**
   * @generated from field: uint32 current_balance_cents = 8;
   */
  currentBalanceCents = 0;

  /**
   * @generated from field: uint32 credit_limit_amount_cents = 9;
   */
  creditLimitAmountCents = 0;

  /**
   * @generated from field: uint32 past_due_amount_cents = 10;
   */
  pastDueAmountCents = 0;

  /**
   * @generated from field: uint32 last_payment_amount_cents = 11;
   */
  lastPaymentAmountCents = 0;

  /**
   * @generated from field: repeated kikoff_canada.protobuf.models.credit.ReportAccount.Payment payment_history = 12;
   */
  paymentHistory: ReportAccount.Payment[] = [];

  /**
   * @generated from field: kikoff_canada.protobuf.models.credit.ReportAccount.ContactInfo contact_info = 13;
   */
  contactInfo?: ReportAccount.ContactInfo;

  /**
   * @generated from field: string description = 14;
   */
  description = "";

  constructor(data?: PartialMessage<ReportAccount>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "kikoff_canada.protobuf.models.credit.ReportAccount";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "type", kind: "enum", T: proto3.getEnumType(ReportAccount.Type) },
    { no: 4, name: "opened_at", kind: "message", T: Timestamp },
    { no: 5, name: "closed_at", kind: "message", T: Timestamp, opt: true },
    { no: 6, name: "last_reported_at", kind: "message", T: Timestamp },
    { no: 7, name: "last_activity_at", kind: "message", T: Timestamp },
    { no: 8, name: "current_balance_cents", kind: "scalar", T: 13 /* ScalarType.UINT32 */ },
    { no: 9, name: "credit_limit_amount_cents", kind: "scalar", T: 13 /* ScalarType.UINT32 */ },
    { no: 10, name: "past_due_amount_cents", kind: "scalar", T: 13 /* ScalarType.UINT32 */ },
    { no: 11, name: "last_payment_amount_cents", kind: "scalar", T: 13 /* ScalarType.UINT32 */ },
    { no: 12, name: "payment_history", kind: "message", T: ReportAccount.Payment, repeated: true },
    { no: 13, name: "contact_info", kind: "message", T: ReportAccount.ContactInfo },
    { no: 14, name: "description", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ReportAccount {
    return new ReportAccount().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ReportAccount {
    return new ReportAccount().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ReportAccount {
    return new ReportAccount().fromJsonString(jsonString, options);
  }

  static equals(a: ReportAccount | PlainMessage<ReportAccount> | undefined, b: ReportAccount | PlainMessage<ReportAccount> | undefined): boolean {
    return proto3.util.equals(ReportAccount, a, b);
  }

  static _enums: {
    Type: typeof ReportAccount.Type,
  };
}

export namespace ReportAccount {
  /**
   * @generated from enum kikoff_canada.protobuf.models.credit.ReportAccount.Type
   */
  export enum Type {
    /**
     * @generated from enum value: OTHER = 0;
     */
    OTHER = 0,

    /**
     * @generated from enum value: INSTALLMENT = 1;
     */
    INSTALLMENT = 1,

    /**
     * @generated from enum value: REVOLVING = 2;
     */
    REVOLVING = 2,

    /**
     * @generated from enum value: MORTGAGE = 3;
     */
    MORTGAGE = 3,

    /**
     * @generated from enum value: INQUIRY = 4;
     */
    INQUIRY = 4,

    /**
     * @generated from enum value: COLLECTION = 5;
     */
    COLLECTION = 5,
  }
  // Retrieve enum metadata with: proto3.getEnumType(ReportAccount.Type)
  proto3.util.setEnumType(ReportAccount.Type, "kikoff_canada.protobuf.models.credit.ReportAccount.Type", [
    { no: 0, name: "OTHER" },
    { no: 1, name: "INSTALLMENT" },
    { no: 2, name: "REVOLVING" },
    { no: 3, name: "MORTGAGE" },
    { no: 4, name: "INQUIRY" },
    { no: 5, name: "COLLECTION" },
  ]);
}

export namespace ReportAccount {
  /**
   * @generated from message kikoff_canada.protobuf.models.credit.ReportAccount.Payment
   */
  export class Payment extends Message<ReportAccount.Payment> {
    /**
     * @generated from field: google.protobuf.Timestamp date = 1;
     */
    date?: Timestamp;

    /**
     * @generated from field: kikoff_canada.protobuf.models.credit.ReportAccount.Payment.Status status = 2;
     */
    status = ReportAccount.Payment.Status.OTHER;

    constructor(data?: PartialMessage<ReportAccount.Payment>) {
      super();
      proto3.util.initPartial(data, this);
    }

    static readonly runtime: typeof proto3 = proto3;
    static readonly typeName = "kikoff_canada.protobuf.models.credit.ReportAccount.Payment";
    static readonly fields: FieldList = proto3.util.newFieldList(() => [
      { no: 1, name: "date", kind: "message", T: Timestamp },
      { no: 2, name: "status", kind: "enum", T: proto3.getEnumType(ReportAccount.Payment.Status) },
    ]);

    static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ReportAccount.Payment {
      return new ReportAccount.Payment().fromBinary(bytes, options);
    }

    static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ReportAccount.Payment {
      return new ReportAccount.Payment().fromJson(jsonValue, options);
    }

    static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ReportAccount.Payment {
      return new ReportAccount.Payment().fromJsonString(jsonString, options);
    }

    static equals(a: ReportAccount.Payment | PlainMessage<ReportAccount.Payment> | undefined, b: ReportAccount.Payment | PlainMessage<ReportAccount.Payment> | undefined): boolean {
      return proto3.util.equals(ReportAccount.Payment, a, b);
    }

    static _enums: {
      Status: typeof ReportAccount.Payment.Status,
    };
  }
}

export namespace ReportAccount.Payment {
  /**
   * @generated from enum kikoff_canada.protobuf.models.credit.ReportAccount.Payment.Status
   */
  export enum Status {
    /**
     * @generated from enum value: OTHER = 0;
     */
    OTHER = 0,

    /**
     * @generated from enum value: CURRENT = 1;
     */
    CURRENT = 1,

    /**
     * @generated from enum value: UNAVAILABLE = 2;
     */
    UNAVAILABLE = 2,

    /**
     * @generated from enum value: LATE_LESS_THAN_30_DAYS = 13;
     */
    LATE_LESS_THAN_30_DAYS = 13,

    /**
     * @generated from enum value: LATE_30_DAYS = 3;
     */
    LATE_30_DAYS = 3,

    /**
     * @generated from enum value: LATE_60_DAYS = 4;
     */
    LATE_60_DAYS = 4,

    /**
     * @generated from enum value: LATE_90_DAYS = 5;
     */
    LATE_90_DAYS = 5,

    /**
     * @generated from enum value: LATE_120_DAYS = 6;
     */
    LATE_120_DAYS = 6,

    /**
     * @generated from enum value: CHARGE_OFF = 7;
     */
    CHARGE_OFF = 7,

    /**
     * @generated from enum value: COLLECTION = 8;
     */
    COLLECTION = 8,

    /**
     * @generated from enum value: REPOSSESSION = 9;
     */
    REPOSSESSION = 9,

    /**
     * @generated from enum value: ZERO_BAL_AND_CURR_ACCT = 10;
     */
    ZERO_BAL_AND_CURR_ACCT = 10,

    /**
     * @generated from enum value: NOT_REPORTED = 11;
     */
    NOT_REPORTED = 11,

    /**
     * @generated from enum value: COLLECTION_CHARGEOFF = 12;
     */
    COLLECTION_CHARGEOFF = 12,
  }
  // Retrieve enum metadata with: proto3.getEnumType(ReportAccount.Payment.Status)
  proto3.util.setEnumType(ReportAccount.Payment.Status, "kikoff_canada.protobuf.models.credit.ReportAccount.Payment.Status", [
    { no: 0, name: "OTHER" },
    { no: 1, name: "CURRENT" },
    { no: 2, name: "UNAVAILABLE" },
    { no: 13, name: "LATE_LESS_THAN_30_DAYS" },
    { no: 3, name: "LATE_30_DAYS" },
    { no: 4, name: "LATE_60_DAYS" },
    { no: 5, name: "LATE_90_DAYS" },
    { no: 6, name: "LATE_120_DAYS" },
    { no: 7, name: "CHARGE_OFF" },
    { no: 8, name: "COLLECTION" },
    { no: 9, name: "REPOSSESSION" },
    { no: 10, name: "ZERO_BAL_AND_CURR_ACCT" },
    { no: 11, name: "NOT_REPORTED" },
    { no: 12, name: "COLLECTION_CHARGEOFF" },
  ]);
}

export namespace ReportAccount {
  /**
   * @generated from message kikoff_canada.protobuf.models.credit.ReportAccount.Preview
   */
  export class Preview extends Message<ReportAccount.Preview> {
    /**
     * @generated from field: string id = 1;
     */
    id = "";

    /**
     * @generated from field: string name = 2;
     */
    name = "";

    /**
     * @generated from field: string text = 3;
     */
    text = "";

    /**
     * @generated from field: kikoff_canada.protobuf.models.credit.ReportAccount.Preview.MeasureType measure_type = 4;
     */
    measureType = ReportAccount.Preview.MeasureType.UNKNOWN;

    /**
     * @generated from field: string measure_value = 5;
     */
    measureValue = "";

    /**
     * @generated from field: bool is_open = 6;
     */
    isOpen = false;

    /**
     * @generated from field: kikoff_canada.protobuf.models.credit.ReportAccount.Type account_type = 7;
     */
    accountType = ReportAccount.Type.OTHER;

    /**
     * @generated from field: bool is_kikoff_account = 8;
     */
    isKikoffAccount = false;

    /**
     * @generated from field: repeated kikoff_canada.protobuf.models.credit.ReportAccount.Payment payment_history = 9;
     */
    paymentHistory: ReportAccount.Payment[] = [];

    constructor(data?: PartialMessage<ReportAccount.Preview>) {
      super();
      proto3.util.initPartial(data, this);
    }

    static readonly runtime: typeof proto3 = proto3;
    static readonly typeName = "kikoff_canada.protobuf.models.credit.ReportAccount.Preview";
    static readonly fields: FieldList = proto3.util.newFieldList(() => [
      { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
      { no: 2, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
      { no: 3, name: "text", kind: "scalar", T: 9 /* ScalarType.STRING */ },
      { no: 4, name: "measure_type", kind: "enum", T: proto3.getEnumType(ReportAccount.Preview.MeasureType) },
      { no: 5, name: "measure_value", kind: "scalar", T: 9 /* ScalarType.STRING */ },
      { no: 6, name: "is_open", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
      { no: 7, name: "account_type", kind: "enum", T: proto3.getEnumType(ReportAccount.Type) },
      { no: 8, name: "is_kikoff_account", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
      { no: 9, name: "payment_history", kind: "message", T: ReportAccount.Payment, repeated: true },
    ]);

    static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ReportAccount.Preview {
      return new ReportAccount.Preview().fromBinary(bytes, options);
    }

    static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ReportAccount.Preview {
      return new ReportAccount.Preview().fromJson(jsonValue, options);
    }

    static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ReportAccount.Preview {
      return new ReportAccount.Preview().fromJsonString(jsonString, options);
    }

    static equals(a: ReportAccount.Preview | PlainMessage<ReportAccount.Preview> | undefined, b: ReportAccount.Preview | PlainMessage<ReportAccount.Preview> | undefined): boolean {
      return proto3.util.equals(ReportAccount.Preview, a, b);
    }

    static _enums: {
      MeasureType: typeof ReportAccount.Preview.MeasureType,
    };
  }
}

export namespace ReportAccount.Preview {
  /**
   * @generated from enum kikoff_canada.protobuf.models.credit.ReportAccount.Preview.MeasureType
   */
  export enum MeasureType {
    /**
     * @generated from enum value: UNKNOWN = 0;
     */
    UNKNOWN = 0,

    /**
     * @generated from enum value: UTILIZATION = 1;
     */
    UTILIZATION = 1,

    /**
     * @generated from enum value: BALANCE = 2;
     */
    BALANCE = 2,

    /**
     * @generated from enum value: ON_TIME_PAYMENTS = 3;
     */
    ON_TIME_PAYMENTS = 3,

    /**
     * deprecated: not used by payment history
     *
     * @generated from enum value: MISSED_PAYMENTS = 4;
     */
    MISSED_PAYMENTS = 4,

    /**
     * @generated from enum value: ACCOUNT_CODE = 5;
     */
    ACCOUNT_CODE = 5,

    /**
     * @generated from enum value: CREDIT_AGE = 6;
     */
    CREDIT_AGE = 6,

    /**
     * @generated from enum value: COLLECTIONS = 7;
     */
    COLLECTIONS = 7,

    /**
     * @generated from enum value: ACCOUNT_STATUS = 8;
     */
    ACCOUNT_STATUS = 8,
  }
  // Retrieve enum metadata with: proto3.getEnumType(ReportAccount.Preview.MeasureType)
  proto3.util.setEnumType(ReportAccount.Preview.MeasureType, "kikoff_canada.protobuf.models.credit.ReportAccount.Preview.MeasureType", [
    { no: 0, name: "UNKNOWN" },
    { no: 1, name: "UTILIZATION" },
    { no: 2, name: "BALANCE" },
    { no: 3, name: "ON_TIME_PAYMENTS" },
    { no: 4, name: "MISSED_PAYMENTS" },
    { no: 5, name: "ACCOUNT_CODE" },
    { no: 6, name: "CREDIT_AGE" },
    { no: 7, name: "COLLECTIONS" },
    { no: 8, name: "ACCOUNT_STATUS" },
  ]);
}

export namespace ReportAccount {
  /**
   * @generated from message kikoff_canada.protobuf.models.credit.ReportAccount.ContactInfo
   */
  export class ContactInfo extends Message<ReportAccount.ContactInfo> {
    /**
     * @generated from field: string name = 1;
     */
    name = "";

    /**
     * @generated from field: kikoff_canada.protobuf.types.pii.Address address = 2;
     */
    address?: Address;

    /**
     * @generated from field: string phone = 3;
     */
    phone = "";

    constructor(data?: PartialMessage<ReportAccount.ContactInfo>) {
      super();
      proto3.util.initPartial(data, this);
    }

    static readonly runtime: typeof proto3 = proto3;
    static readonly typeName = "kikoff_canada.protobuf.models.credit.ReportAccount.ContactInfo";
    static readonly fields: FieldList = proto3.util.newFieldList(() => [
      { no: 1, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
      { no: 2, name: "address", kind: "message", T: Address },
      { no: 3, name: "phone", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    ]);

    static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ReportAccount.ContactInfo {
      return new ReportAccount.ContactInfo().fromBinary(bytes, options);
    }

    static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ReportAccount.ContactInfo {
      return new ReportAccount.ContactInfo().fromJson(jsonValue, options);
    }

    static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ReportAccount.ContactInfo {
      return new ReportAccount.ContactInfo().fromJsonString(jsonString, options);
    }

    static equals(a: ReportAccount.ContactInfo | PlainMessage<ReportAccount.ContactInfo> | undefined, b: ReportAccount.ContactInfo | PlainMessage<ReportAccount.ContactInfo> | undefined): boolean {
      return proto3.util.equals(ReportAccount.ContactInfo, a, b);
    }

    static _enums: {
    };
  }
}

